import Helper from './Helper';

class CardHeights {
  constructor(config = {}) {
    const {
      cardContainerSelector,
      cardSelector,
      breakpoint
    } = config;
    this.cardContainers = document.getElementsByClassName(cardContainerSelector);
    this.cardSelector = cardSelector;
    this.cards = document.getElementsByClassName(cardSelector);
    this.breakpoint = breakpoint || 768;
    // this.cardContainersArray = Array.prototype.slice.call(this.cardContainers);
    // this.cardsArray = Array.prototype.slice.call(this.cards);
    this.cardContainersArray = Array.from(this.cardContainers);
    this.cardsArray = Array.from(this.cards);
    this.currentScreenWidth = window.innerWidth;

    if(this.cards.length > 0){
      this.bindEvents();
    }
  }

  bindEvents(){

    if (this.currentScreenWidth > this.breakpoint) {
      this.calcCardHeight();
    }

    window.addEventListener("resize", () => {
      const vw = window.innerWidth;

      if (vw > this.breakpoint) {
        this.calcCardHeight();
      } else {
        this.removeCardHeight();
      }
    });
  }

  calcCardHeight() {
    this.removeCardHeight();
    this.cardContainersArray.forEach((container, i) => {
      let maxHeight = 0;
      // let cardsArray = Array.prototype.slice.call(container.querySelectorAll(this.cardSelector));
      let cardsArray = container.getElementsByClassName(this.cardSelector);

      cardsArray.forEach((card, i) => {
        let cardHeight = card.offsetHeight;
        if ( maxHeight < cardHeight ) {
          maxHeight = cardHeight;
        }
      });

      cardsArray.forEach((card, i) => {
        card.style.height = maxHeight + "px";
      });
    });
  }

  removeCardHeight() {
    this.cardsArray.forEach((card, i) => {
      card.style.height = null;
      card.style.removeProperty("height");
    });
  }

}

export default CardHeights;
